import { SentryErrorBoundary } from '@/lib/sentry';
import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';

function App() {
  return (
    <AppProvider>
      <SentryErrorBoundary>
        <AppRoutes />
      </SentryErrorBoundary>
    </AppProvider>
  );
}

export default App;
